import { FaQuoteRight } from 'react-icons/fa';
import { Autoplay, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';

import student01 from '../../../../Images/icons/user-06.webp';
import student02 from '../../../../Images/icons/user-12.jpg';
import student03 from '../../../../Images/icons/user-13.jpg';
import student04 from '../../../../Images/icons/user-14.jpg';
import SectionTitle from '../../../SectionTitle/SectionTitle';

import './ClientTestimonial.css';

const ClientTestimonial = () => {
  return (
    <>
      <section className='pb-[80px] pt-[80px] bg-[#f2f4f7]'>
        <div className='mx-auto px-4 sm:px-6 container lg:px-8'>
          <SectionTitle
            title='See What Our Learners Are  Saying'
            subtitle='Learner Reviews'
          />

          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={30}
            pagination={{ clickable: true }}
            autoplay={{
              delay: 2000,
              pauseOnMouseEnter: true,
              disableOnInteraction: false,
            }}
            speed={400}
            loop={true}
            breakpoints={{
              0: {
                slidesPerView: 1,
                spaceBetween: 10,
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 15,
              },
              992: {
                slidesPerView: 2,
                spaceBetween: 15,
              },
              1200: {
                slidesPerView: 3,
                spaceBetween: 23,
              },
            }}
          >
            <SwiperSlide>
              <div className='bg-gradient-to-br from-emerald-50 to-blue-50 rounded-[10px] p-[30px] relative border border-[#E0E5EB]'>
                <div className='mb-5'>
                  <p className='text-neutral-700 font-siliguri text-base'>
                    &quot;The hands-on welding training was excellent. The
                    instructors guided me step by step, and the practical
                    exercises helped me build confidence. With the institute’s
                    support, I got a MIG Welder job in Saudi Arabia. Highly
                    recommended for anyone. &quot;
                  </p>
                </div>
                <div className='flex items-center gap-3'>
                  <img
                    className='w-[55px] h-[55px] object-cover rounded-full'
                    src={student01}
                    alt='users'
                  />
                  <div>
                    <h4 className='text-[17px] leading-7 font-semibold text-[#162726]'>
                      Rahim Uddin
                    </h4>
                    <p className='text-[14px] text-primary font-medium'>
                      MIG Welder (Saudi Arabia)
                    </p>
                  </div>
                </div>
                <div>
                  <FaQuoteRight className='text-primary text-[54px] leading-[62px] absolute right-[30px] bottom-[30px] opacity-[0.1]' />
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className='bg-gradient-to-br from-emerald-50 to-blue-50 rounded-[10px] p-[30px] relative border border-[#E0E5EB]'>
                <div className='mb-5'>
                  <p className='text-neutral-700 font-siliguri text-base'>
                    &quot;The welding course was fully practical and
                    industry-oriented. After completing the training, the
                    institute helped me with interview preparation and
                    documents. Now I am working in Dubai as an ARC Welder.
                    Highly satisfied with their support.&quot;
                  </p>
                </div>
                <div className='flex items-center gap-3'>
                  <img
                    className='w-[55px] h-[55px] object-cover rounded-full'
                    src={student02}
                    alt='users'
                  />
                  <div>
                    <h4 className='text-[17px] leading-7 font-semibold text-[#162726]'>
                      Alamgir Hossain
                    </h4>
                    <p className='text-[14px] text-primary font-medium'>
                      ARC Welder (Dubai)
                    </p>
                  </div>
                </div>
                <div>
                  <FaQuoteRight className='text-primary text-[54px] leading-[62px] absolute right-[30px] bottom-[30px] opacity-[0.1]' />
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className='bg-gradient-to-br from-emerald-50 to-blue-50 rounded-[10px] p-[30px] relative border border-[#E0E5EB]'>
                <div className='mb-5'>
                  <p className='text-neutral-700 font-siliguri text-base'>
                    &quot;I learned advanced TIG welding techniques with modern
                    equipment. The instructors were experienced and friendly.
                    After the course, I received full support for overseas job
                    placement. Currently, I am working in Qatar as a TIG
                    Welder.&quot;
                  </p>
                </div>
                <div className='flex items-center gap-3'>
                  <img
                    className='w-[55px] h-[55px] object-cover rounded-full'
                    src={student03}
                    alt='users'
                  />
                  <div>
                    <h4 className='text-[17px] leading-7 font-semibold text-[#162726]'>
                      Md. Hasan Ali
                    </h4>
                    <p className='text-[14px] text-primary font-medium'>
                      TIG Welder (Qatar)
                    </p>
                  </div>
                </div>
                <div>
                  <FaQuoteRight className='text-primary text-[54px] leading-[62px] absolute right-[30px] bottom-[30px] opacity-[0.1]' />
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className='bg-gradient-to-br from-emerald-50 to-blue-50 rounded-[10px] p-[30px] relative border border-[#E0E5EB]'>
                <div className='mb-5'>
                  <p className='text-neutral-700 font-siliguri text-base'>
                    &quot;I had zero experience in welding, but the trainers
                    taught me from basic to advanced level. The institute guided
                    me for abroad job placement. Now I am working in Malaysia as
                    a Structural Welder. This training truly changed my
                    career.&quot;
                  </p>
                </div>
                <div className='flex items-center gap-3'>
                  <img
                    className='w-[55px] h-[55px] object-cover rounded-full'
                    src={student04}
                    alt='users'
                  />
                  <div>
                    <h4 className='text-[17px] leading-7 font-semibold text-[#162726]'>
                      Sohel Rana
                    </h4>
                    <p className='text-[14px] text-primary font-medium'>
                      Structural Welder (Malaysias)
                    </p>
                  </div>
                </div>
                <div>
                  <FaQuoteRight className='text-primary text-[54px] leading-[62px] absolute right-[30px] bottom-[30px] opacity-[0.1]' />
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </section>
    </>
  );
};

export default ClientTestimonial;
